import { toFormData } from "axios";
import { Paged } from "../../models/Paged";
import { Video } from "../../models/Video";
import { slavtHTTP } from "../http";

export function getVideos(page: number, size = 10) {
  return slavtHTTP
    .get<Paged<Video>>(`/videos?page=${page}&size=${size}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getVideoDetails(videoId: string) {
  return slavtHTTP
    .get<Video>(`/videos/${videoId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createVideo(video: Video) {
  return slavtHTTP
    .post<{ id: number }>("/videos", toFormData(video), {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editVideo(video: Video) {
  return slavtHTTP
    .patch<{ id: number }>(`/videos/${video.id}`, toFormData(video), {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteVideo(videoId: string) {
  return slavtHTTP
    .delete<void>(`/videos/${videoId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function updateVideoStatus(videoId: string, status: Video["status"]) {
  return slavtHTTP
    .patch<void>(`/videos/${videoId}/status`, { status })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
